module.exports = __webpack_public_path__ + "img/opt.57f676c5.png";